export const hello = () => {
    const styles = ['background: #252525', 'color: white', 'padding: 20px 10%', 'line-height: 40px', 'text-align: center'].join(';');
    console.log('%c Slam Lookbook fw17 by Adoratorio', styles);
};


/** WEBPACK FOOTER **
 ** ./components/plugins.js
 **/